import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { loadConfig } from "./config";
import "./styles/globals.css";

async function bootstrap() {
  const config = await loadConfig();
  const root = ReactDOM.createRoot(document.getElementById("root")!);
  root.render(
    <React.StrictMode>
      <App config={config} />
    </React.StrictMode>,
  );
}

bootstrap().catch((err) => {
  const el = document.getElementById("root");
  if (el) {
    el.innerHTML = `<pre style="color:#E24B4A;padding:2rem;font-family:monospace">MAGI console failed to start:\n${String(err)}</pre>`;
  }
  // eslint-disable-next-line no-console
  console.error(err);
});
